window.addEventListener("load", function() {

    loadMinicart()

    var minicartButtonHeader = document.querySelector("[data-button-toggle-minicart]");
	var minicartPanel = document.querySelector("[data-minicart-panel]");
	var minicartHtml = document.querySelector("html");
	// minicartButtonHeader.addEventListener("click", function(e) {
	// 	//loadMinicart();
	// 	minicartPanel.classList.toggle("open");
	// 	minicartHtml.classList.toggle("minicart-open"); 
	// 	$('.minicart-success').hide();
	// });
    
    jQuery( "[data-button-toggle-minicart]" ).click(function() {
		//loadMinicart();
		minicartPanel.classList.toggle("open");
		minicartHtml.classList.toggle("minicart-open"); 
		$('.minicart-success').hide();
    });

	var minicartButtonClose = document.querySelector("[data-button-close-minicart]");
	minicartButtonClose.addEventListener("click", function(e) {
		//loadMinicart();
		minicartHtml.classList.toggle("minicart-open"); 
	});
	
	$(document).mouseup(e => {
      	console.log('Mouse up');
		if (!$('.minicart-panel').is(e.target) && $('.minicart-panel').has(e.target).length === 0) {
			$('.minicart-panel').removeClass('open');
			$("html").removeClass("minicart-open");
			$('.minicart-success').hide();
			$('.minicart-success span.update-text').text('added to'); 
		}
	});
     
});

function loadMinicart() {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
            var wrapper = document.querySelector('#cart-items')
            var json = JSON.parse(xhr.response)
            if(json.items.length){
                document.getElementById("minicart-panel-items-loading").innerHTML = null;
                for (var i = 0; i < json.items.length; i++){
                    var newDiv = document.createElement('div')
                    newDiv.innerHTML = renderCartItem(json.items[i], i)
                    wrapper.appendChild(newDiv)
                }
            } else if (!json.items.length) {
                document.getElementById("minicart-panel-items-loading").innerHTML = "Your cart is empty";
            }
            console.log(json);
          	var totalPrice = json.total_price / 100;
            document.getElementById('minicartTotalPrice').innerHTML = '$'+totalPrice.toFixed(2);
            document.getElementById('minicartNumberOfItems').innerHTML = json.item_count   
            //when done append the div into the carts wrapper location
            // set a div to innerHTML your array of shit
        } else {
            console.log('Loading the minicart data has failed');
        }
        console.log('The load minicart function has been called');
    };
    xhr.open('GET', 'https://' + window.location.hostname + '/cart.js');
    xhr.send();    
}

function renderCartItem(cartItem, i){
  	var itemPrice = cartItem.price / 100 * cartItem.quantity;

  var sellingPlan = "";
  if(cartItem.selling_plan_allocation && cartItem.selling_plan_allocation.selling_plan){
      sellingPlan = cartItem.selling_plan_allocation.selling_plan.name;
      }
    
    return '<div class="line-item">' +
'                   <div class="content">' +
'                       <div class="item-image">' +
'                           <a href="' + cartItem.url +'">' +
'                               <img src="' + cartItem.image + '" alt="">' +
'                           </a>' +
'                       </div>' +
'                       <div class="item-details">' +
'                           <h4 class="item-title">' +
'                               <a href="' + cartItem.url +'">' + cartItem.title+ '</a>' +
'                           </h4>' +
                            '<div class="selling-plan">'+ sellingPlan +'</div>'+
'                           <div class="item-price">' +
'                               <div class="text-left"><strong>$' + itemPrice.toFixed(2) + '</strong></div>' +
'                           </div>' +
'                       </div>' +
'                   </div>' +
'              </div>'
}
